import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslationData } from '@monorepo/interfaces';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationLoader implements TranslateLoader {
    private readonly http = inject(HttpClient);

    public getTranslation(lang: string): Observable<TranslationData> {
        return this.http.get<TranslationData>(`/assets/i18n/${lang}.json`);
    }
}
